export default {
  publish: 'Опублікувати',
  unpublish: 'Зняти з публікації',
  publishAnyway: 'Все одно опублікувати',
  cancel: 'Скасувати',
  warningsTitle: 'Попередження публікації',
  noWarnings: 'Попереджень немає. Готово до публікації.',
  confirmPublish: 'Опублікувати цей конфігуратор?',
  preview: {
    plural: 'Прев’ю',
    variant: 'Варіант',
    slots: 'Слоти',
    zones: 'Зони',
    allowedParts: 'Дозволені частини',
    allowedMaterials: 'Дозволені матеріали',
    default: 'за замовчуванням',
    empty: 'Даних для прев’ю поки немає',
    noVariants: 'У цього конфігуратора немає варіантів',
    model: '3D-модель',
    noModel: 'Немає 3D-моделі для цього варіанта',
    playerLoadFailed: 'Не вдалося завантажити плеєр конфігуратора',
    controlsTitle: 'Конфігурація',
    partsLoading: 'завантажуються деталі…',
    partsFailed: 'Частина деталей не завантажилася — їх немає у сцені',
    noControls: 'У цьому варіанті немає що налаштовувати',
    noCandidatesForSlot: 'Для цього слота немає деталей',
    options: 'Опції'
  }
};
